export const DEFAULT_ITEMS_PER_PAGE = 4;

export const CATEGORY_ID = {
  PERFUME: 1,
  CLOTHING: 30001,
};

export const CATEGORY_MAP = {
  [CATEGORY_ID.PERFUME]: "Nước Hoa",
  [CATEGORY_ID.CLOTHING]: "Quần Áo",
};

export const bestSellerSlugs = [
  "ao-thun-nam-de-vinc-co-tron-basic-tay-ngan-ao-phong-nam-cotton-cao-cap-sang-trong-lich-lam-90001",
  "quan-tay-nam-de-vinc-cap-chun-co-gian-de-chiu-quan-tay-nam-cotton-cao-cap-sang-trong-lich-lam-120001",
  "ao-polo-nam-thoang-khi-thoai-mai-vai-coolmax-tron-basic-nam-tinh-sang-trong-thanh-lich-de-vinc-60001",
  "ao-ni-dai-tay-lot-long-cao-mem-min-de-vinc-chat-vai-cotton-thoang-mat-day-dan-am-ap-180001",
];
